import { render, staticRenderFns } from "./InviteToGame.vue?vue&type=template&id=62562ebc&scoped=true"
import script from "./InviteToGame.vue?vue&type=script&lang=js"
export * from "./InviteToGame.vue?vue&type=script&lang=js"
import style0 from "./InviteToGame.vue?vue&type=style&index=0&id=62562ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62562ebc",
  null
  
)

export default component.exports